var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M4.39014 5.5C3.83785 5.5 3.39014 5.94772 3.39014 6.5V6.68945L12.3902 12.1229L21.3901 6.68949V6.5C21.3901 5.94772 20.9424 5.5 20.3901 5.5H4.39014Z",
          fill: "#5021D1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M21.3901 7.9744L15.5082 11.5254L21.3901 15.9369V7.9744Z",
          fill: "#5021D1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M21.3901 17.3119L14.4924 12.1386L12.3902 13.4078L10.2879 12.1386L3.39014 17.3119V17.5C3.39014 18.0523 3.83785 18.5 4.39014 18.5H20.3901C20.9424 18.5 21.3901 18.0523 21.3901 17.5V17.3119Z",
          fill: "#5021D1",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M3.39014 15.9369L9.27216 11.5254L3.39014 7.97437V15.9369Z",
          fill: "#5021D1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }